import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

'use strict'

const fpNews = {

    init: function() {
        this.slider();
    },

    slider: function() {
        const swiper = new Swiper('.fpNews__slider', {
            modules: [Navigation],
            loop: false,
            slidesPerView: 1,
            spaceBetween: 30,
            navigation: {
                nextEl: '.fpNews-button-next',
                prevEl: '.fpNews-button-prev',
            },
            breakpoints: {
                650: {
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                992: {
                    slidesPerView: 3,
                    spaceBetween: 30,
                },
            }
        });
    }
}

export default fpNews;